var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentAddOutline18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.75h1.5v-3h3v-1.5h-3v-3h-1.5v3h-3v1.5h3v3zM9 16.5a7.3 7.3 0 01-2.925-.591 7.569 7.569 0 01-2.381-1.603 7.569 7.569 0 01-1.603-2.381A7.3 7.3 0 011.5 9a7.3 7.3 0 01.591-2.925 7.569 7.569 0 011.603-2.381A7.58 7.58 0 016.075 2.09 7.307 7.307 0 019 1.5c1.037 0 2.012.197 2.925.59a7.58 7.58 0 012.381 1.604 7.569 7.569 0 011.603 2.381A7.3 7.3 0 0116.5 9a7.3 7.3 0 01-.591 2.925 7.569 7.569 0 01-1.603 2.381 7.569 7.569 0 01-2.381 1.603A7.3 7.3 0 019 16.5zM9 15c1.675 0 3.094-.581 4.256-1.744C14.42 12.094 15 10.675 15 9c0-1.675-.581-3.094-1.744-4.256C12.094 3.58 10.675 3 9 3c-1.675 0-3.094.581-4.256 1.744C3.58 5.906 3 7.325 3 9c0 1.675.581 3.094 1.744 4.256C5.906 14.42 7.325 15 9 15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentAddOutline18);
export default __webpack_public_path__ + "a0a8928ce49d89235c85168a207dba92.svg";
export { ForwardRef as ReactComponent };